import { NOTIFICATION_STATUSES, useNotifications, } from "@adsk/alloy-react-notification";
var TOAST_TIMEOUT = 5;
/**
 * useToasts
 * This hook provides methods to show success/error toasts (Alloy notifications), making sure all toasts in the app behave in the same way.
 *
 */
export var useToasts = function () {
    var showNotification = useNotifications().showNotification;
    return {
        showSuccessToast: function (message) {
            return showNotification({
                status: NOTIFICATION_STATUSES.SUCCESS,
                autoDismiss: TOAST_TIMEOUT,
                showIcon: true,
                message: message,
            });
        },
        showErrorToast: function (message) {
            return showNotification({
                status: NOTIFICATION_STATUSES.ERROR,
                autoDismiss: TOAST_TIMEOUT,
                showIcon: true,
                message: message,
            });
        },
        showInfoToast: function (message) {
            return showNotification({
                status: NOTIFICATION_STATUSES.INFO,
                autoDismiss: TOAST_TIMEOUT,
                showIcon: true,
                message: message,
            });
        },
    };
};
